import React from "react";
import styled from "@emotion/styled";
import Image from "@components/item/Image";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@emotion/react";

const Container = styled.div({
  width: "25.2rem",
  display: "flex",
  flexDirection: "column",
  gap: "1.2rem",
});
const ImageWrapper = styled.div({
  width: "100%",
  height: "15.6rem",
  position: "relative",
  objectFit: "cover",
});

const DescWrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  width: "25.2rem",
  gap: "0.8rem",
});

const Nickname = styled.p(({ theme }) => ({
  position: "absolute",
  top: "12rem",
  left: "2rem",
  color: theme.color.white,
  fontSize: "1.4rem",
  lineHeight: "2rem",
  fontWeight: theme.fontWeight.regular,
}));

type Props = {
  id: number;
  nickname?: string;
  src: string;
};

const CuratedSellerCard = ({ nickname, src, id }: Props) => {
  const navigate = useNavigate();
  const theme = useTheme();

  const handleSellerClick = (sellerId: number) => {
    navigate(`/seller/${sellerId}`);
  };
  return (
    <Container onClick={() => handleSellerClick(id)}>
      <ImageWrapper>
        <Image
          src={src || theme.image.default_card_image.default}
          width="100%"
          height="100%"
        />
      </ImageWrapper>

      <DescWrapper>
        <Nickname>{nickname}</Nickname>
      </DescWrapper>
    </Container>
  );
};

export default CuratedSellerCard;
